// 量表
export default [{ // 量表管理
  path: '/scaleTemplate',
  name: 'scaleTemplate',
  component: resolve => require(['@/views/scale/scaleTemplate/scaleTemplate.vue'], resolve),
  meta: {
    group: "/scaleTemplate",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 新增量表
  path: '/addScale',
  name: 'addScale',
  component: resolve => require(['@/views/scale/scaleTemplate/addScale.vue'], resolve),
  meta: {
    group: "/scaleTemplate",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 编辑量表
  path: '/editScale',
  name: 'editScale',
  component: resolve => require(['@/views/scale/scaleTemplate/addScale.vue'], resolve),
  meta: {
    group: "/scaleTemplate",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 查看量表
  path: '/viewScale',
  name: 'viewScale',
  component: resolve => require(['@/views/scale/scaleTemplate/addScale.vue'], resolve),
  meta: {
    group: "/scaleTemplate",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 新增报告规则
  path: '/reportingRules',
  name: 'reportingRules',
  component: resolve => require(['@/views/scale/scaleTemplate/reportingRules.vue'], resolve),
  meta: {
    group: "/scaleTemplate",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 新增预警规则
  path: '/earlyWarningRules',
  name: 'earlyWarningRules',
  component: resolve => require(['@/views/scale/scaleTemplate/earlyWarningRules.vue'], resolve),
  meta: {
    group: "/scaleTemplate",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 跳转规则
  path: '/jumpRules',
  name: 'jumpRules',
  component: resolve => require(['@/views/scale/scaleTemplate/jumpRules.vue'], resolve),
  meta: {
    group: "/scaleManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 量表分类模板
  path: '/scaleTypeTemplate',
  name: 'scaleTypeTemplate',
  component: resolve => require(['@/views/scale/scaleTypeTemplate/scaleTypeTemplate.vue'], resolve),
  meta: {
    group: "/scaleTypeTemplate",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/scale/scale.js